import {useState, useEffect} from 'react';

export const useDropdownPosition = (
  dropdownRef,
  sidebarRef,
  isDropdownOpen,
) => {
  const [dropdownPosition, setDropdownPosition] = useState('bottom-right');

  useEffect(() => {
    const updateDropdownPosition = () => {
      if (!dropdownRef.current || !sidebarRef.current) return;

      const sidebarRect = sidebarRef.current.getBoundingClientRect();
      const dropdownRect = dropdownRef.current.getBoundingClientRect();

      let position = '';

      // Determine vertical position
      if (window.innerHeight - sidebarRect.bottom >= dropdownRect.height) {
        position = 'bottom-';
      } else if (sidebarRect.top >= dropdownRect.height) {
        position = 'top-';
      }

      // Determine horizontal position
      if (window.innerWidth - sidebarRect.right >= dropdownRect.width) {
        position += 'right ';
      } else if (sidebarRect.left >= dropdownRect.width) {
        position += 'left ';
      }

      setDropdownPosition(position.trim());
    };

    if (isDropdownOpen) {
      updateDropdownPosition();
      window.addEventListener('resize', updateDropdownPosition);
    }

    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }, [dropdownRef, sidebarRef, isDropdownOpen]);

  return dropdownPosition;
};
